module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle",
    attrs: {
      "id": "book"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rbook"
    }
  }, [_vm._v("How to Use This Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("Hello, my beautiful readers! I could not be more excited to welcome you. These pages were created to guide you in discovering the youthful and radiant skin and complexion you desire.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("In order for you to fully understand how to achieve both short-term results and long-term success, start by reading "), _c('a', {
    attrs: {
      "href": "#/Part001"
    }
  }, [_vm._v("Part I")]), _vm._v(" carefully. It will give you valuable insight and a basic understanding of the significance of our food choices, the role of digestion, and how food and digestion play an instrumental role in our overall complexion. You will also discover everyday foods for beautiful skin and how to go about go about integrating them into your diet. "), _c('span', {
    attrs: {
      "href": "#/Part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")]), _vm._v(" provides individualized guides to help start your detox program, including delicious and satiating recipes, meal plans, supplement suggestions, and skincare recommendations. If you are in a pinch for time, skip to "), _c('span', {
    attrs: {
      "href": "#/Part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")]), _vm._v(" to get started, but be sure to go back to "), _c('a', {
    attrs: {
      "href": "#/Part001"
    }
  }, [_vm._v("Part I")]), _vm._v(" for background information.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("In the appendix you will find additional invaluable tools to help you grocery shop and dine out, as well as a quick reference guide for all your basic needs.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("May this labor of love serve you well. You deserve to know the truth about beauty.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("You were created to shine!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0848570a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book.vue
// module id = 72
// module chunks = 0